import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';


const ContableRegistroGastoForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, contablecuentaCombo, contablegastoCombo, fechas, cursoCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["ContableRegistroGasto"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["cursoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["cursoId"]:""} 
                                    name="cursoId"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
                    
        
                        <Form  >          
                            <Form.Field  required  error={errors.comentario}>            
                              <label  >{strings?strings["comentario"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["comentario"]:""} 
                                    name="comentario"
                                    onChange={onChange}
                                    value={datos.comentario}
                                    icon='edit'/>
                            </Form.Field>
        
        
                            <Form.Field required>
                                <label  >{strings?strings["fechaRegistro"]:""}</label>  
                                <DatePicker 
                                        bordered={false}
                                        value={dayjs(datos.fechaRegistro, dateFormat)}
                                        onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                        locale={locale} 
                                        size="large" 
                                        allowClear={false}
                                        format={dateFormat} />
                                        
                                        
                            
                            </Form.Field>    
        
                            <Form.Field  required  error={errors.monto}>            
                              <label  >{strings?strings["monto"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["monto"]:""} 
                                    name="monto"
                                    onChange={onChange}
                                    value={datos.monto}
                                    icon='edit'/>
                            </Form.Field>
                                            
        
                             <Form.Field  required  error={errors.contableCuentaId}>
                              <label  >{strings?strings["contableCuentaId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["contableCuentaId"]:""} 
                                    name="contableCuentaId"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.contableCuentaId}
                                    options={contablecuentaCombo}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.contableGastoId}>
                              <label  >{strings?strings["contableGastoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["contableGastoId"]:""} 
                                    name="contableGastoId"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.contableGastoId}
                                    options={contablegastoCombo}/>
                            </Form.Field>
        
                                           
                            <Form.Field  required  error={errors.factura}>            
                              <label  >{strings?strings["factura"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["factura"]:""} 
                                    name="factura"
                                    onChange={onChange}
                                    value={datos.factura}
                                    icon='edit'/>
                            </Form.Field>
                                            
                         
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/contableregistrogastos">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ContableRegistroGastoForm;